import _ from 'lodash'
import { parse, format } from 'url'
import { encodeModulesToLoad } from '@wix/thunderbolt-commons'
import type { OoiCssViewerModelFunctionLibrary } from 'thunderbolt-viewer-model-root'

const encodeModulesToLoadCacheKey = (args: Array<{ id: string; url?: string }>) =>
	encodeModulesToLoad(_(args).filter('url').sortBy('id').value() as Array<{ id: string; url: string }>)

const buildCssConfigUrl = (originUrl: string) => {
	try {
		const { pathname, ...urlParts } = parse(originUrl)
		const parts = pathname?.split('/') || []
		const filename = parts.pop()
		const [k, ...rest] = filename?.split('.') ?? []
		return format({
			...urlParts,
			pathname: `${parts.join('/')}/${k}.cssConfig.${rest.join('.')}`,
		})
	} catch (error) {
		return originUrl
	}
}

const functionLib: OoiCssViewerModelFunctionLibrary = {
	encodeModulesToLoadCacheKey,
	buildCssConfigUrl,
}

export default { ...functionLib }
